import React, { Fragment, useState, useEffect } from 'react';
import { Pill, Users, Award, Clock } from 'lucide-react';
import './home.css'

import HomeCards from "./home-cards"

const HomePage = () => {

    // useEffect(() => {
    //     axios.get('http://localhost:5300/api/tables')
    //         .then(response => {
    //             setData(response.data);
    //             console.log(response.data)
    //         })
    //         .catch(error => {
    //             console.error('There was an error fetching data:', error);
    //         })
    // }, []);

    return (
        <Fragment>
            {/* <div className='home-container'> */}

            <div className="heroHome-container">

                {/* Hero Section */}
                <section
                    className="hero-section"
                // style={{
                //     opacity: heroOpacity,
                //     transform: `scale(${heroScale})`
                // }}
                >
                    <div className="hero-overlay"></div>
                    <div className="hero-gradient"></div>

                    {/* Animated background elements */}
                    {/* <div className="hero-bg-animation">
                        <div className="hero-blob hero-blob-1"></div>
                        <div className="hero-blob hero-blob-2"></div>
                    </div> */}

                    <div className="hero-content">
                        <div className="hero-icon-wrapper">
                            <Pill className="hero-icon" strokeWidth={1.5} />
                        </div>
                        <h1 className="hero-title">
                            Your path to wellness<br />
                        </h1>
                        <p className="hero-description">
                            We are a highly trained and well-educated team that is committed to providing all our patients with quality care.
                        </p>

                        {/* <HomeCards /> */}

                    </div>


                </section>

                {/* <div className='home-container'>

                    <div className='home-titles'>
                        <div className='home-heading'>
                            <p>Your path to wellness</p>
                            <p>We are a highly trained and well-educated team that is committed to providing all our patients with quality care.</p>
                        </div>

                        <div className='rx-div'>

                        </div>
                    </div>

                </div> */}

                {/* <HomeCards /> */}
                {/* <HomeContact /> */}

            </div>

        </Fragment>

    )

};

export default HomePage;